module.exports = __webpack_public_path__ + "img/illu-bug.6c8370e9.svg";